"use strict";
/*************************************************************************
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
const Global_1 = require("./src/Global");
const Events_1 = require("./metrics/Events");
exports.Events = Events_1.Events;
const Level_1 = require("./metrics/Level");
exports.Level = Level_1.Level;
const api = Global_1.connect('metrics', [
    ['create', true]
]);
exports.default = api;
/**
 * @ignore
 */
class MetricsRuntime {
    static configure(config) {
        return Global_1.getImpl('metrics').configure(config);
    }
}
exports.MetricsRuntime = MetricsRuntime;
//# sourceMappingURL=metrics.js.map